import type { ModalConfig } from "./types";

export const ticketModalsModalUrlConfig = {
  // Ticket Modals
  "tickets-detail": {
    modalId: "tickets-detail",
    entityName: "tickets",
    singularParam: "ticketId",
    pluralParam: "ticketsId",
    displayName: "Ticket",
  },
  "create-tickets": {
    modalId: "create-tickets",
    entityName: "tickets",
    singularParam: "ticketId",
    pluralParam: "ticketsId",
    displayName: "Ticket",
  },
  "edit-tickets": {
    modalId: "edit-tickets",
    entityName: "tickets",
    singularParam: "ticketId",
    pluralParam: "ticketsId",
    displayName: "Ticket",
  },
} as const satisfies Record<string, ModalConfig>;
